import Weather from "./components/Weather";

const App = () => {
  return (
    <div>
      <Weather />
    </div>
  );
};

export default App;
